import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  CircularProgress,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  Dialog,
} from "@mui/material";
import HeaderTitle from "../../../components/common/HeaderTitle/HeaderTitle";
import axios from "axios";
import { API_ENDPOINT } from "../../../services/api/resources";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const RcPoView = ({
  selectedContract,
  onBack,
  rcInputRef,
  loading,
  setLoading,
}) => {
  const loginData = useSelector((state) => state.loginData.value);
  const auth_token = loginData?.auth_token;
  const buyer_token = loginData?.user?.token;

  const [savedItem, setSavedItem] = useState([]);
  const [quantities, setQuantities] = useState({});

  const [deliveryDate, setDeliveryDate] = useState("");
  const [paymentDate, setPaymentDate] = useState("");
  const [creatingPo, setCreatingPo] = useState(false);

  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const navigate = useNavigate();

  const fetchRcItems = async () => {
    try {
      setLoading(true);

      const res = await axios.post(
        API_ENDPOINT.get_rc_items_,
        {
          buyer_token: buyer_token,
          rc_token: selectedContract?.rc_token || selectedContract?.token,
        },
        {
          headers: {
            Authorization: `Token ${auth_token}`,
            "Content-Type": "application/json",
          },
        }
      );

      setSavedItem(res.data || []);
    } catch (error) {
      console.error("Error fetching RC Items:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRcItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleQtyChange = (id, value) => {
    if (!/^\d*$/.test(value)) return;

    setQuantities((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const grandTotal = savedItem.reduce((sum, item) => {
    const qty =
      quantities[item.id] !== undefined
        ? Number(quantities[item.id] || 0)
        : Number(item.quantity || 0);
    const rate = Number(item.rate || 0);
    return sum + qty * rate;
  }, 0);

  const handleCreatePO = async () => {
    try {
      setCreatingPo(true);

      const payload = {
        rate_contract_token: selectedContract?.rc_token,
        rfq_id: null,
        delivery_date: deliveryDate + "T00:00:00Z",
        payment_date: paymentDate + "T00:00:00Z",
        items: savedItem.map((item) => ({
          id: item.id,
          item_name: item.item_name,
          uom: item.uom,
          rate: Number(item.rate),
          // quantity: Number(quantities[item.id] || 0),
          quantity: item.quantity,
          remarks: item.remarks || "",
        })),
        demo: savedItem,
      };

      console.log("FINAL PAYLOAD:", payload);

      await axios.post(API_ENDPOINT.convert_rate_contract_to_po, payload, {
        headers: {
          Authorization: `Token ${auth_token}`,
          "Content-Type": "application/json",
        },
      });

      setShowSuccessModal(true);
    } catch (err) {
      console.error("CREATE PO ERROR:", err);
      alert("Failed to create PO");
    } finally {
      setCreatingPo(false);
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      {/* HEADER */}
      <Box
        sx={{
          mt: 1,
          mb: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <HeaderTitle titleText="Rate Contract Items" />
        <Button
          variant="contained"
          size="small"
          sx={{
            fontSize: 15,
            fontWeight: 600,
            textTransform: "none",
            px: 1.5,
            py: 1,
            borderRadius: 1.5,
          }}
          onClick={onBack}
        >
          Back
        </Button>
      </Box>

      {/* FILE UPLOAD BOX (unchanged) */}
      {/* <Box
                onDragOver={ (e) => e.preventDefault() }
                sx={ {
                    mb: "20px",
                    width: "100%",
                    maxWidth: "420px",
                    border: "2px dashed #cbd5e1",
                    borderRadius: "12px",
                    padding: "40px",
                    textAlign: "center",
                    backgroundColor: "#f8fafc",
                    cursor: "pointer",
                    "&:hover": { backgroundColor: "#f1f5f9" },
                } }
            >
                <Typography
                    variant="h6"
                    sx={ {
                        fontWeight: 600,
                        fontSize: 16,
                        color: "#334155",
                        mb: 0.5,
                    } }
                >
                    Drag and drop file here
                </Typography>
                <Typography sx={ { color: "#64748b", fontSize: 14, mb: 2 } }>
                    (Supported format .xlsx, .xls, .csv)
                </Typography>
                <Button
                    variant="outlined"
                    size="medium"
                    sx={ {
                        borderRadius: 2,
                        textTransform: "none",
                        fontSize: 14,
                        fontWeight: 500,
                        px: 2.5,
                    } }
                    onClick={ () => rcInputRef.current.click() }
                >
                    Browse
                </Button>
                <input
                    type="file"
                    ref={ rcInputRef }
                    style={ { display: "none" } }
                    onChange={ (e) => console.log("Selected:", e.target.files[0]) }
                />
            </Box> */}

      {/* UPLOAD BUTTON */}
      {/* <Button
                variant="contained"
                sx={ {
                    fontFamily: "GilroyMedium",
                    textTransform: "none",
                    fontWeight: 600,
                    fontSize: "14px",
                    borderRadius: 1,
                    px: 2.5,
                    py: 1,
                    mb: 3,
                } }
                disabled={ loading }
            >
                { loading ? <CircularProgress size={ 18 } color="inherit" /> : "Upload File" }
            </Button> */}

      {/* ITEMS TABLE */}
      <TableContainer
        component={Paper}
        sx={{
          borderRadius: 2,
          boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {["Item Name", "Rate", "Remarks", "Quantity", "UOM", "Total"].map(
                (header, i) => (
                  <TableCell
                    key={i}
                    sx={{
                      fontWeight: 600,
                      fontFamily: "GilroySemiBold",
                      backgroundColor: "#e0e9ee",
                      fontSize: "14px",
                    }}
                  >
                    {header}
                  </TableCell>
                )
              )}
            </TableRow>
          </TableHead>

          <TableBody>
            {savedItem.map((item) => {
              const qty =
                quantities[item.id] !== undefined
                  ? quantities[item.id]
                  : item.quantity || "";
              const total = (Number(item.rate) || 0) * (Number(qty) || 0);

              return (
                <TableRow key={item.id}>
                  <TableCell
                    sx={{ fontSize: "14px", fontFamily: "GilroyMedium" }}
                  >
                    {item.item_name}
                  </TableCell>

                  <TableCell
                    sx={{ fontSize: "14px", fontFamily: "GilroyMedium" }}
                  >
                    ₹{Number(item.rate).toLocaleString("en-IN")}
                  </TableCell>

                  <TableCell
                    sx={{ fontSize: "14px", fontFamily: "GilroyMedium" }}
                  >
                    {item.remarks || "—"}
                  </TableCell>

                  <TableCell>
                    <TextField
                      value={
                        quantities[item.id] !== undefined
                          ? quantities[item.id]
                          : item.quantity || ""
                      }
                      onChange={(e) => handleQtyChange(item.id, e.target.value)}
                      placeholder="0"
                      type="text"
                      sx={{
                        width: "80px",
                        "& .MuiInputBase-root": {
                          fontSize: "14px",
                          fontFamily: "GilroyMedium",
                        },
                      }}
                    />
                  </TableCell>

                  <TableCell
                    sx={{ fontSize: "14px", fontFamily: "GilroyMedium" }}
                  >
                    {item.uom}
                  </TableCell>

                  <TableCell
                    sx={{
                      fontSize: "14px",
                      fontFamily: "GilroySemiBold",
                      color: "#075b97",
                    }}
                  >
                    ₹{Number(total.toFixed(2)).toLocaleString("en-IN")}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      {/* DELIVERY DATE + PAYMENT DATE */}
      <Box sx={{ mt: 3, display: "flex", gap: 3 }}>
        <TextField
          label="Delivery Date"
          type="date"
          value={deliveryDate}
          onChange={(e) => setDeliveryDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          sx={{
            width: "250px",
            "& .MuiInputBase-root": {
              fontSize: "14px",
              fontFamily: "GilroyMedium",
            },
          }}
        />

        <TextField
          label="Payment Date"
          type="date"
          value={paymentDate}
          onChange={(e) => setPaymentDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          sx={{
            width: "250px",
            "& .MuiInputBase-root": {
              fontSize: "14px",
              fontFamily: "GilroyMedium",
            },
          }}
        />
      </Box>

      {/* GRAND TOTAL SECTION */}
      <Box
        sx={{
          mt: 3,
          p: 2,
          borderRadius: 2,
          backgroundColor: "#f0f7fa",
          border: "1px solid #cbd5e1",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            fontSize: "18px",
            fontFamily: "GilroySemiBold",
            color: "#075b97",
          }}
        >
          Grand Total
        </Typography>

        <Typography
          sx={{
            fontSize: "20px",
            fontWeight: 700,
            fontFamily: "GilroySemiBold",
            color: "#075b97",
          }}
        >
          ₹{grandTotal.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
        </Typography>
      </Box>

      {/* CREATE PO BUTTON */}
      <Button
        variant="contained"
        sx={{
          mt: 3,
          fontFamily: "GilroyMedium",
          textTransform: "none",
          fontWeight: 600,
          fontSize: "14px",
          borderRadius: 1,
          px: 2.5,
          py: 1,
        }}
        color="primary"
        onClick={handleCreatePO}
        disabled={creatingPo}
      >
        {creatingPo ? (
          <CircularProgress size={18} color="inherit" />
        ) : (
          "Create PO"
        )}
      </Button>

      <Dialog
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
      >
        <Box
          sx={{
            p: 3,
            width: 400,
            textAlign: "center",
            borderRadius: 2,
          }}
        >
          <Typography
            sx={{
              fontSize: "24px",
              fontWeight: 800,
              mb: 2,
              color: "#075b97",
              fontFamily: "GilroySemiBold",
            }}
          >
            PO Created Successfully!
          </Typography>

          <Typography
            sx={{
              fontSize: 16,
              color: "#475569",
              fontFamily: "GilroyMedium",
              mb: 3,
            }}
          >
            Your Purchase Order has been generated.
          </Typography>

          <Button
            variant="contained"
            sx={{
              textTransform: "none",
              fontFamily: "GilroyMedium",
              fontWeight: 600,
              borderRadius: 1.5,
              width: "100px",
              fontSize: "16px",
            }}
            // onClick={ () => setShowSuccessModal(false) }
            onClick={() => navigate("/Buyer_dashboard/po")}
          >
            OK
          </Button>
        </Box>
      </Dialog>
    </Box>
  );
};

export default RcPoView;
